import {
    GET_STYLE_WISE_INVENTORY_ERROR, GET_STYLE_WISE_INVENTORY_REQUEST, GET_STYLE_WISE_INVENTORY_SUCCESS
} from "../actions/types";

export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_STYLE_WISE_INVENTORY_REQUEST:
            return {
                loading: true,
            };
        case GET_STYLE_WISE_INVENTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_STYLE_WISE_INVENTORY_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };

        default: {
            return state;
        }
    }
};
